import { Word } from '@attain-apps/string-builder'

import type * as models from '../models'
/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<TItem extends models.Item<unknown> = models.Item<any>> {
  lookup: State.Lookup<TItem>
  /** TODO: add documentation */
  selectedIds: Set<string>
  /**
   * @see {@link models.DialogConfig}
   */
  // TODO figure out how to handle optional position. Possible options:
  // 1. Use default position
  // 2. If there is no position, do not open the dialog and assume that
  //    pasting is happening behind the scenes
  dialogConfig?: models.DialogConfig
  /*
   * Represents the class reference used to filter clipboard items, ensuring
   * that only one specific type can be pasted at a time.
   */
  paster?: models.Paster<TItem>
}
export namespace State {
  export const INITIAL: State = {
    lookup: {},
    selectedIds: new Set(),
  }

  /** TODO:  */
  export function addSelection(state: State, ...ids: readonly string[]): State {
    return {
      ...state,
      selectedIds: new Set([...state.selectedIds, ...ids]),
    }
  }
  export function removeSelection(
    state: State,
    ...ids: readonly string[]
  ): State {
    return {
      ...state,
      selectedIds: new Set(
        [...state.selectedIds].filter(id => !ids.includes(id)),
      ),
    }
  }
  export function setSelection(state: State, ...ids: readonly string[]): State {
    return {
      ...state,
      selectedIds: new Set(ids),
    }
  }
  export function releaseSelection(state: State): State {
    return {
      ...state,
      selectedIds: new Set(),
    }
  }

  /** TODO:  */
  export type Lookup<TItem extends models.Item<unknown> = models.Item<any>> =
    Partial<Record<string, models.Item<TItem>>>
  export namespace Lookup {
    /** TODO: documentation */
    export function insert(
      state: State,
      ...items: readonly models.Item<any>[]
    ): State {
      const lookup = { ...state.lookup }
      for (const item of items) {
        lookup[Word.generate()] = item
      }
      return { ...state, lookup }
    }

    export function removeSelected(state: State): State {
      const lookup = { ...state.lookup }
      for (const id of state.selectedIds) {
        delete lookup[id]
      }
      return { ...state, lookup }
    }

    /** TODO: documentation */
    export function remove(state: State, ...id: readonly string[]): State {
      const lookup = { ...state.lookup }
      for (const key of id) {
        delete lookup[key]
      }
      return { ...state, lookup }
    }
  }
}
